import { render } from "./ColumnProperties.vue?vue&type=template&id=ba3c9442"
import script from "./ColumnProperties.vue?vue&type=script&lang=js"
export * from "./ColumnProperties.vue?vue&type=script&lang=js"

import "./ColumnProperties.vue?vue&type=style&index=0&id=ba3c9442&lang=scss"

import exportComponent from "/app/tmp/origina/V3/v2026.5.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__